import styled from 'styled-components'
import { Media } from '../../theme'

export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  bottom: 130px;
  right: 26px;
  cursor: pointer;
  z-index: 10;
  ${Media.lessThan(Media.small)} {
    bottom: 95px;
    right: 25px;
  }
`

export const ActionList = styled.div<{ $showActions: boolean }>`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  opacity: ${({ $showActions }) => ($showActions ? 1 : 0)};
  pointer-events: ${({ $showActions }) => ($showActions ? 'auto' : 'none')};
  transform: translateY(${({ $showActions }) => ($showActions ? '0' : '8px')});
  transition:
    opacity 0.2s,
    transform 0.2s;

  ${Media.lessThan(Media.small)} {
    opacity: 1;
    pointer-events: auto;
    transform: none;
  }
`

export const FloatIcon = styled.div<{
  $hoverBgColor?: string
  $hoverSvgColor?: string
  $hideInMobile?: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 10px;
  transition: all 0.3s;
  box-shadow: 0px 10px 10px 0px #99999940;
  svg {
    fill: #222222;
    transition: all 0.3s;
  }
  &:hover {
    background: ${({ $hoverBgColor }) => ($hoverBgColor ? $hoverBgColor : '#F3512B')};
    svg {
      fill: ${({ $hoverSvgColor }) => ($hoverSvgColor ? $hoverSvgColor : '#fff')};
    }
  }
  ${Media.lessThan(Media.small)} {
    display: ${({ $hideInMobile }) => ($hideInMobile ? 'none' : 'flex')};
  }
`

export const EmailItem = styled.div<{ $hideInMobile: boolean }>`
  display: flex;
  align-items: center;
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 10px;
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  cursor: pointer;
  overflow: hidden;
  svg {
    fill: #222222;
    transition: all 0.3s;
    margin: 0 12px;
    flex-shrink: 0;
  }
  box-shadow: 0px 10px 10px 0px #99999940;
  &:hover {
    width: 310px;
    background: #f3512b;
    box-shadow: 0px 10px 10px 0px #f3512b40;
    svg {
      fill: #fff;
    }
  }
  ${Media.lessThan(Media.small)} {
    display: ${({ $hideInMobile }) => ($hideInMobile ? 'none' : 'flex')};
  }
`

export const Anchor = styled.a`
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
`
